// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { WatchQueryFetchPolicy } from '@confluence/apollo-relay-interop/entry-points/apolloTypes.ts';

import { useIsLicensed } from '@confluence/session-data/entry-points/useAccessStatus.ts';
import { useSiteTraits } from '@confluence/targeting/entry-points/useSiteTraits.ts';

import type { SitePersonalizationQuery_experimentalSitePersonalization_attributes as SitePersonalizationAttributes } from './__types__/SitePersonalizationQuery.ts';

export type useSitePersonalizationQueryProps = {
	cloudId: string;
	skip?: boolean;
	fetchPolicy?: WatchQueryFetchPolicy;
};

export const useSitePersonalizationQuery = ({
	skip,
}: useSitePersonalizationQueryProps): {
	loading: boolean;
	error: Error | undefined;
	attributes: SitePersonalizationAttributes[];
} => {
	const isLicensed = useIsLicensed();

	const skipOptions =
		skip ||
		!isLicensed ||
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		Boolean(process.env.REACT_SSR); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests

	const siteTraits = useSiteTraits({ skipBootstrap: skipOptions });

	if (skipOptions) {
		return {
			loading: false,
			error: undefined,
			attributes: [],
		};
	}

	const attributes: SitePersonalizationAttributes[] = siteTraits.data?.attributes || [];
	return {
		loading: siteTraits.loading,
		error: siteTraits.error ?? undefined,
		attributes,
	};
};
